import { DateTime } from 'luxon';

import { DockAppointmentProvider } from './DockAppointmentProvider';
import { DockAppointmentStatus } from './DockAppointmentStatus';

export class DockAppointment {
  id?: number;
  shipmentId?: number;
  shipmentStopId?: number;
  externalUuid?: string;
  status?: DockAppointmentStatus;
  dockAppointmentProvider: DockAppointmentProvider =
    DockAppointmentProvider.CONDUIT;
  scheduledEarliest?: DateTime;
  scheduledLatest?: DateTime;
  actualArrive?: DateTime;
  actualDepart?: DateTime;
  note?: string;

  constructor(opts?: Partial<DockAppointment>) {
    if (opts?.id != null) {
      this.id = opts.id;
    }
    if (opts?.shipmentId != null) {
      this.shipmentId = opts.shipmentId;
    }
    if (opts?.shipmentStopId != null) {
      this.shipmentStopId = opts.shipmentStopId;
    }
    if (opts?.externalUuid != null) {
      this.externalUuid = opts.externalUuid;
    }
    if (opts?.status != null) {
      if (typeof opts?.status === 'string') {
        this.status = DockAppointmentStatus[opts.status];
      } else {
        this.status = opts.status;
      }
    }
    if (opts?.dockAppointmentProvider != null) {
      if (typeof opts?.dockAppointmentProvider === 'string') {
        this.dockAppointmentProvider =
          DockAppointmentProvider[opts.dockAppointmentProvider];
      } else {
        this.dockAppointmentProvider = opts.dockAppointmentProvider;
      }
    }
    if (opts?.scheduledEarliest != null) {
      this.scheduledEarliest = DateTime.fromISO(
        opts.scheduledEarliest.toString(),
      );
    }
    if (opts?.scheduledLatest != null) {
      this.scheduledLatest = DateTime.fromISO(opts.scheduledLatest.toString());
    }
    if (opts?.actualArrive != null) {
      this.actualArrive = DateTime.fromISO(opts.actualArrive.toString());
    }
    if (opts?.actualDepart != null) {
      this.actualDepart = DateTime.fromISO(opts.actualDepart.toString());
    }
    if (opts?.note != null) {
      this.note = opts.note;
    }
  }
}
